const rEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export default function SendEmailValidation(values: any) {
  let errors: any = {};

  if (!values.email) {
    errors.email = 'El email es requerido';
  } else if (!rEmail.test(values.email)) {
    errors.email = 'El email ingresado es inválido';
  }

  return errors;
}
